import { AdminMenuUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

export const fetchAllTests = (page: number) => {
  return new AdminMenuUseCase(
    `/teste/pageTeste?page=${page}`,
    makeAxiosHttpClient()
  )
}
export const saveTest = () => {
  return new AdminMenuUseCase(`/teste/saveTeste`, makeAxiosHttpClient())
}
export const updateTest = () => {
  return new AdminMenuUseCase(`/teste/updateTeste`, makeAxiosHttpClient())
}
